/**
 * Component to load alternative offers and show result
 */
define([
    'jQuery',
    'underscore',
    'library/fcse-compatibility/object',
    'library/fcse-component/optionsMixin',
    'library/fcse-util/url',
    'library/fcse-util/paramConverter',
    'library/fcse-events/eventDispatcher',
    'clientComponents/alternatives/alternativesList'
    ],
    function($, _, Object, OptionsMixin, Url, ParamConverter, EventDispatcher, AlternativesList) {
        /**
         * Creates an alternatives button
         *
         * @param element jQuery selector or DOM element
         * @param {MultiRequestHandler} requestHandler
         * @param {object} options
         * @constructor
         */
        var AlternativesLoadMoreButton = function (element, requestHandler, options) {
            // Call Constructor of parent class
            EventDispatcher.apply(this, arguments);

            // Set elements
            this.element = $(element);
            this.requestHandler = requestHandler;
            this.initialData = true;

            var defaultOptions = {
                routeName: 'allt_frontend.package.detail.alternatives',
                alternativesContainerSelector: '[data-fcse-role="alternatives-container"]',
                offerSelector: '[data-fcse-role="offer-item"]',
                offerListSelector: '[data-fcse-role="offerlist"]',
                alternativesListSelector: '[data-fcse-role="alternativeslist"]'
            };

            // Add default options and custom options
            this.addOptions(defaultOptions, options);

            this.flightAlternatives = this.option('flightAlternatives');
            this.opener = this.flightAlternatives.find(this.option('openerSelector'));
            this.icon = this.opener.find('i.icon');

            this.baseOfferElement = this.flightAlternatives.closest(this.option('offerSelector'));

            this._init();
        };

        AlternativesLoadMoreButton.prototype = $.extend(Object.create(EventDispatcher.prototype), OptionsMixin, {
            _requestData: null,
            _dataLoaded: false,

            /**
             * Initializer
             * @private
             */
            _init: function() {
                var container = this.flightAlternatives.find(this.option('alternativesContainerSelector'));
                var icon = this.icon;

                $(this.element).click($.proxy(this._onClick, this));
                this.requestHandler.on('success', $.proxy(this._handleOfferCheckResponse, this));

                this.opener.on('click', function (e) {
                    container.toggle();
                    icon.toggleClass('icon-plus icon-minus');
                });

                $(this.element).trigger('click');
            },

            /**
             * Alternatives button click handler
             */
            _onClick: function(e) {
                // Check if request is pending
                if (this._requestData !== null){
                    return;
                }

                // Set el visual status to loading
                this.element.addClass('loading');
                var offerListElement = this.flightAlternatives.closest(this.option('offerListSelector'));
                this.element.data().page++;
                // if (this.initialData && (this._resultsTotal > 10)) {
                // }

                if (this._dataLoaded) {
                    return;
                }

                var data = this.element.data();
                var params = {
                    offerIndex: this.baseOfferElement.data('fcse-offer-index'),
                    requestId: offerListElement.data('fcse-request-id'),
                    productSearchId: offerListElement.data('fcse-product-search-id'),
                    productCode: data.productCode,
                    departureAirports: data.departureAirport,
                    arrivalAirports: data.arrivalAirport,
                    departureDate: data.departureDate,
                    returnDate: data.returnDate,
                    duration: data.duration,
                    room: data.room,
                    board: data.board,
                    page: data.page,
                };

                var routeParams = JSON.parse(
                    offerListElement.attr('data-initial-route-params')
                );

                this._requestData = this.requestHandler.send(
                    this.option('routeName'), params, routeParams, {method: 'GET'}
                );
            },

            /**
             * Handle successful response from offer check
             *
             * @param data
             * @param requestData
             * @private
             */
            _handleOfferCheckResponse: function(data, requestData) {
                if (!this._requestData || requestData.route !== this.option('routeName') ||
                    requestData.xhr !== this._requestData.xhr)
                {
                    return;
                }

                // Reset request data
                this._requestData = null;

                // Remove loading state
                this.element.removeClass('loading');

                if (data.state === 'OK') {
                    var container = this.baseOfferElement.find(this.option('alternativesContainerSelector'));
                    var alternatives = container.find('[data-fcse-role="alternative-offers"]');

                    if (alternatives.html().length) {
                        this.initialData = false;
                        alternatives.append(data.html);
                    } else {
                        alternatives.prop('innerHTML', data.html);
                    }

                    var alternativesList = alternatives.find(this.option('alternativesListSelector'));
                    this._resultsTotal = alternativesList.data('results-total');
                    this._resultsPerPage = alternativesList.data('results-per-page');

                    new AlternativesList(
                        alternativesList,
                        this.requestHandler,
                        {offersRoute: 'allt_frontend.hotel.detail.offers'}
                    );

                    var currentPage = this.element.data('page');
                    if (this.initialData && (this._resultsTotal > 10)) {
                        this.element.show();
                    } else if (((currentPage + 1) * this._resultsPerPage) >= this._resultsTotal) {
                        this.element.hide();
                        this._dataLoaded = true;
                    }

                    if (this.option('flightAlternatives').is(":visible")) {
                        container.show();
                    } else {
                        if (alternatives.find('[data-fcse-role="offer-item"]').length) {
                            this.option('flightAlternatives').show();
                        }
                    }
                }
            }
        });

        return AlternativesLoadMoreButton;
    }
);



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/alternatives/alternativesLoadMoreButton.js